import { render, staticRenderFns } from "./_HeaderLogo.vue?vue&type=template&id=5841061b&scoped=true"
import script from "./_HeaderLogo.vue?vue&type=script&lang=js"
export * from "./_HeaderLogo.vue?vue&type=script&lang=js"
import style0 from "./_HeaderLogo.vue?vue&type=style&index=0&id=5841061b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5841061b",
  null
  
)

export default component.exports